module.exports = __webpack_public_path__ + "img/medical_english.398166a5.svg";